export{Task,TaskStatus,initialState,shallowArrayEquals}from"./task.js";
//# sourceMappingURL=index.js.map
